






import { defineComponent } from "@vue/composition-api"

export default defineComponent({
  props: {
    text: {
      type: String,
      default: "",
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
})
